import React from 'react';
import ReactDOM from 'react-dom';
const $ = window.$;

export class StickInParent extends React.Component {
  handleRef = (element) => {
    this.element = element;
  }

  componentDidMount() {
    $(ReactDOM.findDOMNode(this.element)).stick_in_parent(this.props.config);
  }

  render() {
    return this.props.children({ref: this.handleRef});
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/StickInParent.js